const DEFAULT_MARGIN_TOP_INDICATOR_DESKTOP = 4;
const DEFAULT_MARGIN_TOP_INDICATOR_MOBILE = 0;
export const calculateMarginTopIndicator = _ref => {
  let {
    isMobile,
    isMultiLine,
    indicatorPosition,
    marginTopIndicator
  } = _ref;
  if (indicatorPosition === 'center' || !isMultiLine && indicatorPosition !== 'top') {
    return 0;
  }
  if (marginTopIndicator !== undefined) {
    return marginTopIndicator;
  }
  return isMobile ? DEFAULT_MARGIN_TOP_INDICATOR_MOBILE : DEFAULT_MARGIN_TOP_INDICATOR_DESKTOP;
};